<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 17 17" style="enable-background:new 0 0 21 21;" xml:space="preserve"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
<g>
<path d="M7.1318359,3.4434228v9.1137695c0,0.1806641-0.0634766,0.3339844-0.1899414,0.4609375
s-0.2807617,0.1894531-0.4609375,0.1894531c-0.1811523,0-0.3349609-0.0625-0.4614258-0.1894531l-2.4140625-2.4140625H0.8388672
c-0.1806641,0-0.3344727-0.0634766-0.4609375-0.1904297c-0.1269531-0.1259766-0.1899414-0.2792969-0.1899414-0.4609375V6.0474267
c0-0.1806641,0.0629883-0.3344727,0.1899414-0.4614258c0.1264648-0.1259766,0.2802734-0.1899414,0.4609375-0.1899414h2.7666016
L6.0195312,2.981997C6.1459961,2.8560205,6.2998047,2.7925439,6.480957,2.7925439
c0.1801758,0,0.3344727,0.0634766,0.4609375,0.1894531C7.0683594,3.1089501,7.1318359,3.2627587,7.1318359,3.4434228z
M6.2636719,3.9585595L4.1479492,6.0742822C4.0214844,6.2012353,3.8676758,6.2642236,3.6870117,6.2642236H1.0561523v3.4716802
h2.6308594c0.1806641,0,0.3344727,0.0634766,0.4609375,0.1894531l2.1157227,2.1162109V3.9585595z M9.4643555,5.9658837
C9.355957,5.8936181,9.2426758,5.8755517,9.1254883,5.9116845C9.0078125,5.9483056,8.9174805,6.0156884,8.8540039,6.1152978
S8.7768555,6.3233056,8.8134766,6.4404931C8.8496094,6.5581689,8.9125977,6.6441064,9.003418,6.6983056
C9.2387695,6.8433251,9.4194336,7.0283837,9.5463867,7.254458c0.1259766,0.2260742,0.1894531,0.4746094,0.1894531,0.7456059
c0,0.2714844-0.0634766,0.5200195-0.1894531,0.7456055C9.4194336,8.9722319,9.2387695,9.1577787,9.003418,9.30231
C8.9125977,9.3560209,8.8496094,9.4419584,8.8134766,9.5591459C8.7768555,9.67731,8.7905273,9.7857084,8.8540039,9.8853178
s0.1538086,0.1669922,0.2714844,0.203125c0.1171875,0.0361328,0.2304688,0.0185547,0.3388672-0.0537109
c0.3623047-0.2177734,0.6416016-0.5068359,0.8408203-0.8681641s0.2988281-0.75,0.2988281-1.1665039
c0-0.4155278-0.0996094-0.8041997-0.2988281-1.1660161S9.8266602,6.1826806,9.4643555,5.9658837z M13.2075195,8.0000639
c0-0.8857427-0.2167969-1.704102-0.6503906-2.4545903c-0.4345703-0.75-1.0126953-1.3515625-1.7363281-1.8037109
c-0.1083984-0.0722656-0.2216797-0.090332-0.3388672-0.0541992c-0.1181641,0.0361328-0.2080078,0.1040039-0.2714844,0.203125
c-0.0634766,0.0996094-0.0771484,0.2084961-0.0400391,0.3256836c0.0351562,0.1176758,0.0986328,0.2036133,0.1894531,0.2578125
c0.6142578,0.3793945,1.0986328,0.8813477,1.4511719,1.5053711c0.3525391,0.6235352,0.5292969,1.2978516,0.5292969,2.0205083
c0,0.7231445-0.1767578,1.3969727-0.5292969,2.0209961c-0.3525391,0.6230469-0.8369141,1.125-1.4511719,1.5048828
c-0.0908203,0.0546875-0.1542969,0.140625-0.1894531,0.2578125c-0.0371094,0.1181641-0.0234375,0.2265625,0.0400391,0.3251953
c0.0634766,0.0996094,0.1533203,0.1679688,0.2714844,0.2041016c0.1171875,0.0361328,0.2304688,0.0175781,0.3388672-0.0546875
c0.7236328-0.4521484,1.3017578-1.0527344,1.7363281-1.8037109C12.9907227,9.7046537,13.2075195,8.8862944,13.2075195,8.0000639z
M15.8120117,8.0000639c0,1.3383789-0.3310547,2.581543-0.9902344,3.7290039
c-0.6601562,1.1494141-1.5419922,2.0664062-2.6445312,2.7539062c-0.1083984,0.0537109-0.2216797,0.0673828-0.3388672,0.0400391
c-0.1181641-0.0263672-0.2080078-0.0908203-0.2714844-0.1894531c-0.0634766-0.0996094-0.0771484-0.2080078-0.0410156-0.3251953
c0.0361328-0.1181641,0.0996094-0.2041016,0.1904297-0.2578125c0.9941406-0.6152344,1.7802734-1.4287109,2.359375-2.4414062
c0.578125-1.0126953,0.8681641-2.1152344,0.8681641-3.309082c0-1.1933599-0.2900391-2.2958989-0.8681641-3.3090825
c-0.5791016-1.012207-1.3652344-1.8261719-2.359375-2.440918c-0.0908203-0.0546875-0.1542969-0.1401367-0.1904297-0.2578125
s-0.0224609-0.2260742,0.0410156-0.3256836c0.0634766-0.0991211,0.1533203-0.1625977,0.2714844-0.1899414
c0.1171875-0.0268555,0.2304688-0.0131836,0.3388672,0.0410156c1.1025391,0.6875,1.984375,1.6049805,2.6445312,2.7529297
C15.480957,5.4190087,15.8120117,6.6621728,15.8120117,8.0000639z"/>
</g>
</svg>
</template>

<script>
    export default {
        name: "AudioIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>
